export var MARKETING_EMAIL_OPT_IN_COLLAPSED = 'MARKETING_EMAIL_OPT_IN_COLLAPSED';
